@if (hasCloseButton) {
    <button type="button" class="close" (click)="close.emit($event)">
        <kui-icon name="times"></kui-icon>
    </button>
}
<ng-content></ng-content>
